<template>
  <div class="page">
    <div v-if="model != null">
      <van-panel class="panel-info">
        <!-- '['+ model.id +']'-->
        <van-cell
          slot="header"
          :title="
            $store.state.OrderTypeEnum.getLabel(model.type)  +
            (model.itemType == 'gaming' ? '（电竞单）' : '')
            +
            (model.options
              ? model.options.isExcludeOrderedClerk
                ? '(排除单)'
                : ''
              : '')
          "
          icon="orders-o"
        >
          <van-tag v-if="model.status == 0" size="medium" type="danger"
            >待接单</van-tag
          >
          <van-tag v-else-if="model.status == 1" color="#ff976a" size="medium"
            >待开始</van-tag
          >
          <van-tag v-else-if="model.status == 2" size="medium" type="primary"
            >服务中</van-tag
          >
          <van-tag v-else-if="model.status == 3" size="medium" type="success"
            >已完成</van-tag
          >
          <van-tag v-else-if="model.status == -1" size="medium">已取消</van-tag>
        </van-cell>
        <div class="content">
          <!--    用户信息      -->
          <div
            v-if="model.type != 'random' && model.user != null"
            class="row"
            style="margin-top: 0"
          >
            <div class="user_head">
              <img
                :src="model.user.headImgUrl"
                height="60px"
                style="border-radius: 50%"
                width="60px"
              />
              <div
                class="avatarFrame"
                v-if="
                  model.levelFrameUrl &&
                  !model.user.hideLevelSwitch &&
                  ((model.type == 'assigned' && $ClerkPermission.visibleAssignedOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value))
                  ||(model.type== 'reward' && $ClerkPermission.visibleRewardOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value)))
                  "
              >
                <img
                  width="80px"
                  height="80px"
                  :src="model.levelFrameUrl"
                />
              </div>

              <template v-if="!model.user.hideLevelSwitch">
                <van-tag
                  v-if="
                    model.type == 'assigned' &&
                   $ClerkPermission.visibleAssignedOrderUserInfo.includes(UserInfoEnum.LEVEL.value)
                  "
                  class="level"
                  round
                  size="medium"
                  type="primary"
                >
                  {{ model.levelName }}
                </van-tag>
                <van-tag
                  v-if="
                    model.type == 'reward' &&
                   $ClerkPermission.visibleRewardOrderUserInfo.includes(UserInfoEnum.LEVEL.value)"
                  class="level"
                  round
                  size="medium"
                  type="primary"
                >
                  {{ model.levelName }}
                </van-tag>
              </template>
            </div>
            <div class="margin-left">
              <div>
                <template v-if="!$hasFeature('customization_1508')" >
                  <van-tag plain type="primary">ID：{{ model.user.id }}</van-tag>
                </template>
                <template v-else>
                  <van-tag plain type="primary" v-if="model.user.number">
                    靓号：{{ model.user.number }}
                  </van-tag>
                  <van-tag plain type="primary" v-else>ID：{{ model.user.id }}</van-tag>
                </template>
              </div>
              <template v-if="$hasFeature('customization_1508')">
                <div style="display: flex;align-items: center;margin: 2px 0"
                     v-if="model.userKnighthoodInfo &&!model.userKnighthoodInfo.isPastDue">
                  <span>爵位：</span>
                  <img :src="model.userKnighthoodInfo.iconUrl" height="25px">
                </div>
              </template>
              <div>
                <span class="value">{{ model.user.nickname }}</span>
              </div>
              <div v-if="model.distributorName" style="height: 20px;line-height: 20px;font-size: 12px;color: #999999;">
                推荐人：{{ model.distributorName }}
              </div>
            </div>
            <div v-if="$store.state.shop.id == 1788 && (model.status == 0 || model.status == 1 || model.status == 2)" style="position:absolute;right: 20px">
              <router-link :to="'/chat/' + model.user.id">
                <van-button
                    size="small"
                    type="primary">私信
                </van-button>
              </router-link>
            </div>
          </div>
          <!--    用户信息      -->
          <div
            v-if="
              model.type == 'random' &&
              model.user != null &&
              Object.values(model.user).filter((i) => {
                return i;
              }).length
            "
            class="row"
            style="margin-top: 0"
          >
            <div class="user_head">
              <img
                v-if="
                  model.status > 0 ||
                  $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.AVATAR.value)"
                :src="model.user.headImgUrl"
                height="60px"
                style="border-radius: 50%"
                width="60px"
              />
              <div
                v-else
                style="width: 60px; height: 60px; display: inline-block"
              ></div>
              <div
                class="avatarFrame"
                v-if="
                  model.levelFrameUrl &&
                  !model.user.hideLevelSwitch && (
                      (model.status !== 0 && $ClerkPermission.visibleRandomOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value)) ||
                     (model.status === 0 && $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.AVATAR_FRAME.value)))
                "
              >
                <img
                  width="80px"
                  height="80px"
                  :src="
                     model.status != -1
                      ? model.levelFrameUrl
                      : null
                  "
                />
              </div>

              <template v-if="!model.user.hideLevelSwitch">
                <van-tag
                  v-if="
                  (model.status !== 0 && $ClerkPermission.visibleRandomOrderUserInfo.includes(UserInfoEnum.LEVEL.value)) ||
                     (model.status === 0 && $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.LEVEL.value))"
                  class="level"
                  round
                  size="medium"
                  type="primary"
                >
                  {{ model.levelName }}
                </van-tag>
              </template>
            </div>
            <div class="margin-left">
              <div class="padding-bottom">
                <template v-if="!$hasFeature('customization_1508')" >
                  <van-tag v-if="model.status > 0 || $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.ID.value)"
                           plain type="primary">ID：{{ model.user.id }}</van-tag>
                </template>
                <template v-else>
                  <template v-if="model.status > 0 || $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.ID.value)">
                    <van-tag plain type="primary" v-if="model.user.number">
                      靓号：{{ model.user.number }}
                    </van-tag>
                    <van-tag plain type="primary" v-else>ID：{{ model.user.id }}</van-tag>
                  </template>
                </template>
              </div>
              <template v-if="$hasFeature('customization_1508')">
                <div style="display: flex;align-items: center;margin: 2px 0;"
                     v-if="model.userKnighthoodInfo &&!model.userKnighthoodInfo.isPastDue">
                  <span>爵位：</span>
                  <img :src="model.userKnighthoodInfo.iconUrl" style="height: 20px">
                </div>
              </template>
              <div>
                <span v-if="model.status > 0 || $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.NICKNAME.value)"
                  class="value">{{ model.user.nickname }}
                </span>
              </div>
              <div v-if="model.distributorName" style="height: 20px;line-height: 20px;font-size: 12px;color: #999999;">
                推荐人：{{ model.distributorName }}
              </div>
            </div>
            <div v-if="$store.state.shop.id == 1788 && (model.status == 1 || model.status == 2)" style="position:absolute;right: 20px">
              <router-link :to="'/chat/' + model.user.id">
                <van-button
                    size="small"
                    type="primary">私信
                </van-button>
              </router-link>
            </div>
          </div>

          <div class="row">
            <span class="label">订单号</span>
            <span class="value">{{ model.no }}</span>
          </div>
          <div v-if="model.type != 'reward'" class="row">
            <span class="label">订单内容</span>
            <span class="value">
              {{
                model.itemCategory != null ? model.itemCategory.name + "-" : ""
              }}
              {{ model.item.names.join("-") }} × {{ model.num }}</span
            >
          </div>
          <div v-if="model.assignmentName" class="row">
            <span class="label">指派人</span>
            <span class="value">
              {{ model.assignmentName }}
            </span>
          </div>
          <div class="row">
            <span class="label">下单时间</span>
            <span class="value">{{
              formatDate(model.createTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
            <span v-if="model.status == 0"
              >已等待 {{ formatTimeDiff(model.createTime, new Date(), 0) }}</span
            >
          </div>
          <div v-if="model.status >= 1" class="row">
            <span class="label">接单时间</span>
            <span class="value">{{
              formatDate(model.confirmTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
            <span v-if="model.status == 1"
              >已等待 {{ formatTimeDiff(model.confirmTime, new Date(), 1) }}</span
            >
          </div>
          <div v-if="model.status >= 2" class="row">
            <span class="label">开始时间</span>
            <span class="value">{{
              formatDate(model.startTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
            <span v-if="model.status == 2"
              >剩余时长
              {{ formatTimeDiff(new Date(), model.expectedEndTime, 2)}}</span
            >
          </div>
          <div v-if="model.status >= 3" class="row">
            <span class="label">结束时间</span>
            <span class="value">{{
              formatDate(model.endTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
        </div>
          <div v-if="model.type==='reward'&& model.rewardGift" class="row">
            <span class="label">礼物</span>
            <span class="value">{{model.rewardGift.name}} x {{model.num}}</span>
          </div>
          <template v-if="model.type==='reward'&& model.blindBoxGiftList">
            <div class="row" v-for="(item,index) in model.blindBoxGiftList" :key="index">
              <span class="label">奖品</span>
              <span class="value">{{ item.name }} x {{ item.num }}</span>
            </div>
          </template>
          <div v-if="model.status == -1" class="row">
            <span class="label">取消时间</span>
            <span class="value">{{
                formatDate(model.cancelTime, "YYYY-MM-DD HH:mm:ss")
              }}</span>
          </div>
          <div v-if="model.isContinued != null" class="row">
            <span class="label">是否续单</span>
            <span class="value">
              <van-icon
                v-if="model.isContinued"
                color="green"
                name="success"
                style="height: 20px; line-height: 20px"
                tag="span"
              />
              <van-icon
                v-if="!model.isContinued"
                color="red"
                name="cross"
                style="height: 20px; line-height: 20px"
                tag="span"
              />
            </span>
            <template v-if="$store.state.shop.id != 8">
              <van-button
                v-if="
                  !model.isContinued &&
                  !model.hasContinuedApply &&
                  (model.status ==
                    $store.state.OrderStatusEnum.IN_SERVICE.value ||
                    model.status == $store.state.OrderStatusEnum.FINISHED.value)
                    && $hasFeature('order_continued_apply')
                "
                size="small"
                style="height: 20px; line-height: 18px"
                type="primary"
                @click="isFirstContinuedChangeFlag(model.id)"
                >申请转为续单
              </van-button>
              <van-tag v-if="model.hasContinuedApply" color="#999"
                >已申请续单</van-tag
              >
            </template>
          </div>
          <div class="row">
            <span class="label">订单金额</span
            ><span class="value">￥{{ formatPrice(model.totalAmount) }}</span>
          </div>
          <div v-if="model.userCoupon" class="row">
            <span class="label">优惠金额</span>
            <span class="value">￥{{ formatPrice(model.userCoupon.amount) }}</span>
          </div>
          <div class="row">
            <span class="label">实付金额</span
            ><span class="value">￥{{ formatPrice(model.payAmount) }}</span>
          </div>
          <div class="row" v-show="model.refundFeeSum">
              <span class="label">退款金额</span>
              <div class="value ">
                <div class="flex align-center">
                  <span>￥{{ formatPrice(model.refundFeeSum) }}</span>
                  <van-button  color="var(--primary-color)" style="height: 24px;line-height: 24px;margin-left: 10px"
                               @click="$router.push(`/order/refund-detail/${model.id}`)">退款记录
                  </van-button>
                </div>
            </div>
          </div>
          <div class="row" v-if="model.clerkGroupId!=3590">
            <span class="label">预计收入</span
            ><span class="value"
              >￥{{ formatPrice(model.clerkWagesAmount || 0) }}
              <span v-if="![1,47].includes(this.$store.state.shop.id)">
                （{{(model.item && model.item.ratioType ? $store.state.OrderRatioTypeEnum.getLabel(model.item.ratioType) : '店员等级提成') + (model.clerkWagesRatio ? model.clerkWagesRatio : '') }}%）
              </span>
              <span v-else-if="[1,47].includes(this.$store.state.shop.id) && model.user && model.user.level && model.levelName">
                (提成联系管理)
              </span>
            </span>
          </div>
          <template v-if="model.type==='assigned' && model.options">
            <div class="row" v-if="model.options.clerkAddress">
              <span class="label">店员地址</span>
              <span class="value">{{ model.options.clerkAddress.address + model.options.clerkAddress.detailAddress }}</span>
            </div>
            <div class="row" v-if="model.options.userAddress">
              <span class="label">用户地址</span>
              <span class="value">{{ model.options.userAddress.address + model.options.userAddress.detailAddress }}</span>
            </div>
            <div class="row" v-if="model.options.distance">
              <span class="label">距离</span>
              <span class="value">{{ model.options.distance }}km</span>
            </div>
            <div class="row" v-if="model.options.distanceFee">
              <span class="label">出行费</span>
              <span class="value">{{ formatPrice(model.options.distanceFee) }}</span>
            </div>
          </template>
          <div
            v-if="model.type == 'random' && model.options != null"
            class="row"
          >
            <span class="label">买家要求</span>
            <span class="value">
              <van-tag
                v-if="model.options.clerkSex != null && model.options.clerkSex != 0"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{$store.state.ClerkSexEnum.getLabel(model.options.clerkSex)}}
              </van-tag>
              <van-tag
                v-if="model.options.clerkSex === 0"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >不分男女</van-tag>
              <van-tag
                v-if="model.options.clerkGrade != null"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{
                  $store.state.ClerkGradeMap[model.options.clerkGrade]
                }}</van-tag
              >
              <van-tag
                v-for="(item, index) in model.options.clerkTags"
                :key="index"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{ item }}</van-tag
              >
            </span>
          </div>
          <div class="row" v-if="model.options != null && model.options.entertainmentStyle">
            <span class="label">娱乐风格</span>
            <span class="value">
                {{ model.options.entertainmentStyle == 'assistance' ? '辅助' : '陪伴' }}
              </span>
          </div>
          <div class="row" v-if="model.options != null && model.options.technologyStyle">
            <span class="label">技术风格</span>
            <span class="value">
                {{ model.options.technologyStyle == 'point' ? '上分' : model.options.technologyStyle == 'star' ? '上星' : '包C' }}
              </span>
          </div>
          <div class="row" v-if="$store.state.shop.id === 47 || $store.state.shop.id === 106">
            <span class="label">服务需求</span>
            <span class="value">{{ model.userServiceMemo }}</span>
          </div>
          <div class="row">
            <span class="label">买家备注</span
            ><span class="value">{{ model.userMemo }}</span>
          </div>
          <template v-if="!($store.state.shop.id === 2814)">
          <div v-if="$store.state.shop.id !== 1916 && ($store.state.shop.id === 127 || model.status != -1) &&
            ((model.type == 'assigned' && $ClerkPermission.visibleAssignedOrderUserInfo.includes(UserInfoEnum.WECHAT.value))
                    || (model.type == 'random' && $ClerkPermission.visibleRandomOrderUserInfo.includes(UserInfoEnum.WECHAT.value))
                    || (model.type == 'reward' && $ClerkPermission.visibleRewardOrderUserInfo.includes(UserInfoEnum.WECHAT.value)))
            " class="row">
            <template v-if="$store.state.shop.id !== 6">
              <span v-if="'wechat_id'===model.contactWay" class="label">买家微信</span>
              <span v-if="'qq_id'===model.contactWay" class="label">买家QQ</span>
              <span v-if="'wechat_qr_code'===model.contactWay" class="label">买家二维码</span>
              <span v-if="'free'===model.contactWay" class="label">买家联系方式</span>
              <span v-if="['wechat_id','qq_id'].includes(model.contactWay)" class="value">{{ model.userWechatId }}</span>
              <span v-if="['wechat_qr_code'].includes(model.contactWay) && (model.status == 1||model.status == 2)" class="value">
                <img :src="model.contactQrCodeUrl" style="width: 150px; height: 150px;" >
              </span>
              <span v-if="['free'].includes(model.contactWay)" class="value">无</span>
              <button
                  v-if="$store.state.shop.id != 2300 && (model.status == 1||model.status == 2)"
                  class="van-button van-button--primary van-button--small wx"
                  @click="$refs.noWechat.show($route.params.id,clerkWechatCode,model.no,noticeTypeList)">
                加不上微信
              </button>
              <button
                  v-if="!model.contactWay || ['wechat_id','qq_id'].includes(model.contactWay)"
                  v-clipboard="copyUserWechatId"
                  class="van-button van-button--primary van-button--small"
                  style="height: 20px; line-height: 18px"
                  @error="copyCallback(false)"
                  @success="copyCallback(true)"
              >
                复制微信号
              </button>
            </template>
            <!--     店铺6店员只能看近7天的用户微信       -->
            <template v-if="$store.state.shop.id === 6 && showCreatedTime(model.createTime)">
              <span v-if="'wechat_id'===model.contactWay" class="label">买家微信</span>
              <span v-if="'qq_id'===model.contactWay" class="label">买家QQ</span>
              <span v-if="'wechat_qr_code'===model.contactWay" class="label">买家二维码</span>
              <span v-if="'free'===model.contactWay" class="label">买家联系方式</span>
              <span v-if="['wechat_id','qq_id'].includes(model.contactWay)" class="value">{{ model.userWechatId }}</span>
              <span v-if="['wechat_qr_code'].includes(model.contactWay) && (model.status == 1||model.status == 2)" class="value">
                <img :src="model.contactQrCodeUrl" style="width: 150px; height: 150px;" >
              </span>
              <span v-if="['free'].includes(model.contactWay)" class="value">无</span>
              <button
                  v-if="model.status == 1||model.status == 2"
                  class="van-button van-button--primary van-button--small wx"
                  @success="$refs.noWechat.show($route.params.id,clerkWechatCode,model.no,noticeTypeList)">
              加不上微信
              </button>
              <button
                v-clipboard="copyUserWechatId"
                class="van-button van-button--primary van-button--small"
                style="height: 20px; line-height: 18px"
                @error="copyCallback(false)"
                @success="copyCallback(true)"
              >
                复制微信号
              </button>
            </template>
          </div>
          </template>

          <div class="row" v-if="sign.kfName">
            <span class="label">客服名称</span
            ><span class="value">{{ sign.kfName }}</span>
          </div>
          <div class="row" v-if="model.isShopCreate && sign.kfName">
            <span class="label">客服名称</span
            ><span class="value">{{ sign.kfName }}</span>
          </div>
<!--          <div class="row" v-if="model.userViolationSignList && model.userViolationSignList.length > 0">-->
<!--            <span class="label">违规记录</span>-->
<!--            <span class="value"><span class="text-blue">{{ model.userViolationSignList.length }}</span>条-->
<!--            <a class="text-blue" @click="showViolation = true">查看</a>-->
<!--            </span>-->
<!--          </div>-->
          <div v-if="model.status == -1 && model.refundList" style="display: flex">
            <div style="min-width: 80px;color: #888">退款信息</div>
            <div>
              <div v-for="(item,index) in model.refundList">
                <span v-if="item.operatorRole === 'super_admin'">退款人：超级管理员</span>
                <span v-if="item.operatorRole === 'admin'">退款人：管理员-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'leader'">退款人：组长-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'kf'">退款人：客服-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'clerk'">退款人：店员-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'user'">退款人：用户</span>
                <span v-if="item.operatorRole === 'system'">退款人：系统</span>
                <span v-if="item.refundDesc" style="padding-left: 10px">原因：{{item.refundDesc}}</span>
              </div>
            </div>
          </div>
          <div v-if="model.refundPhotoUrls && model.refundPhotoUrls.length > 0" class="row">
            <span class="label">取消原因截图</span>
            <div class="screenshot">
              <div class="imgStyle" v-for="(item,index) in model.refundPhotoUrls" :key="index" @click="refundImgClick(index)">
                <img :src="item" class="screenshotImg">
              </div>
            </div>
          </div>
        </div>
      </van-panel>
      <div v-if="model.orderFeedBack != null" class="commentBox">
        <div class="row">
          <span class="label">反馈留言</span
          ><span class="value">{{
            model.orderFeedBack.content == ""
              ? "-"
              : model.orderFeedBack.content
          }}</span>
        </div>
        <div class="row">
          <span class="label">反馈截图</span>
          <div class="screenshot">
            <div
              v-for="(item, index) in model.orderFeedBack.photoUrls"
              :key="index"
              class="imgStyle"
              @click="imgClick(index)"
            >
              <img :src="item" class="screenshotImg" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="model != null" class="bottom-bar">
        <van-button
            v-if="(model.status == 1||model.status == 2 ) && $hasFeature('chat')
            // && [1,141,2184].includes($store.state.shop.id)
                  && this.$store.state.shopSetting.chat.isUsed"
            block
            size="normal"
            style="height: 40px;background-color: #1989fa;color: #FFFFFF;margin-bottom: 10px"
            @click.native="toChat(model.userId)">进入聊天
        </van-button>

        <van-button
          v-if="model.status == 0"
          :disabled="btnConfirmDisabled"
          block
          size="normal"
          type="primary"
          @click.native="confirmOrder"
          >{{
            btnConfirmDisabled ? confirmCountDown + "s后可接单" : "确认接单"
          }}
        </van-button>
        <van-button
          v-if="model.status == 1"
          block
          size="normal"
          type="primary"
          @click.native="startService">开始服务
        </van-button>

        <!--   退款权限     -->
        <template v-if="$ClerkPermission.cancelOrder && $ClerkPermission.refundableOrderStatus.includes(model.status) && model.status!==-1">
          <!--    随机单并且待接单状态不显示取消按钮      -->
          <template v-if="model.type == 'random' ">
            <!--    待服务，服务中显示取消按钮，服务中并且服务时间超过服务时间内不可取消设置则不显示取消按钮      -->
            <div v-if="model.status == 1 || (model.status == 2 && canClerkCancelOrder)" class="margin-top">
              <van-button block size="normal" type="warning" @click="show = true">取消订单</van-button>
            </div>
          </template>
            <!--    指定单      -->
          <template v-else>
            <!--    待接单、待开始、服务中显示取消按钮，服务中并且服务时间超过服务时间内不可取消设置则不显示取消按钮        -->
            <div v-if="model.status == 0 || model.status == 1 || (model.status == 2 && canClerkCancelOrder)" class="margin-top">
              <van-button block size="normal" type="warning" @click="show = true">取消订单</van-button>
            </div>
          </template>
        </template>

        <div
          v-if="model.status == 3 && model.orderFeedBack == null"
          class="margin-top"
        >
          <van-button
            :to="'/clerk/order/orderComment/' + model.id"
            block
            size="normal"
            type="primary"
            >订单反馈</van-button
          >
        </div>
        <div v-if="model.status == 3 && remindUserContinued">
          <van-button v-if="model.remind" block size="normal" color="gray" :disabled="true" style="margin-top: 15px">已提醒续单</van-button>
          <van-button v-if="!model.remind" block size="normal" type="warning" style="margin-top: 15px" @click.native="clickRemindContinued">提醒用户续单</van-button>
        </div>
      </div>

      <certification v-if="isVerify" @close="isVerify = false"></certification>

      <van-dialog
        v-model="showOrderContinuedApplyDialog"
        :beforeClose="onOrderContinuedApplyDialogClose"
        title="续单申请"
        show-cancel-button>
        <van-field
          v-model="orderContinuedApplyMessage"
          label="申请内容"
          placeholder="请输入申请内容"
          rows="2"
          style="background: #f5f5f5;margin: 10px;width: auto"
          type="textarea"/>

<!--        <div style="margin-left: 10px;font-size: 12px">-->
<!--          申请截图（{{this.continuedApplyFileList.length}}/5）-->
<!--        </div>-->
<!--        <van-uploader-->
<!--            v-model="continuedApplyFileList"-->
<!--            :max-count="5"-->
<!--            style="margin: 10px"-->
<!--            accept="image/*"-->
<!--            class="image-uploader"-->
<!--            multiple-->
<!--            preview-size="60"-->
<!--            upload-icon="plus"-->
<!--            :after-read="continuedApplyAfterRead"/>-->

        <uploadPhoto style="padding: 0 15px" :imgArr="this.continuedApplyFileList" imgAmount="5" @uploadimg="uploadimg" title titleText="申请截图"></uploadPhoto>
      </van-dialog>
    </div>
    <van-dialog v-model="show" show-cancel-button title="取消原因" @confirm="cancellation" style="padding: 5px">
        <van-cell-group v-if="model.status === 0 || model.status ===1 || model.status === 2" :border="false" class="module">
        <uploadPhoto :imgArr="this.fileList" imgAmount="3" @uploadimg="uploadimgFile" title titleText="上传截图"></uploadPhoto>
      </van-cell-group>
      <van-field v-model="value" label="原因" maxlength="50" placeholder="最多输入50个字" show-word-limit type="textarea"
                 style="border: 1px solid #eee6e6;"/>
      <van-cell v-if="$ClerkPermission.refundMethod === 'choose'"  :required="true"  title-class="van-cell__title van-field__label">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span class="">返还方式</span>
        </template>
        <template #default>
          <van-radio-group v-model="refundPath">
            <van-radio name="original" :disabled="model.payMode==='balance' || $ClerkPermission.refundMethod!=='choose'">原路返还（{{$store.state.OrderPayModeEnum.valueOf(model.payMode).label}}）</van-radio>
            <van-radio name="balance" :disabled="model.payMode==='balance' || $ClerkPermission.refundMethod!=='choose'" style="margin-top: 10px">返还到余额</van-radio>
          </van-radio-group>
        </template>
      </van-cell>
    </van-dialog>
    <RewardSpecialEffects ref="child" :id="'reward'"></RewardSpecialEffects>
    <!--  查看违规内容  -->
<!--    <ViolationSelect :showViolation="showViolation" :userViolationSignList="model.userViolationSignList"-->
<!--                     @changeShowViolation="changeShowViolation"></ViolationSelect>-->
    <NoWechat ref="noWechat"/>
    <OrderConfirmHint ref="orderConfirmHint"/>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Button,
  Cell, CellGroup,
  Dialog,
  Field,
  Icon,
  ImagePreview,
  Panel,
  Tag,
  Toast, Uploader,RadioGroup, Radio
} from "vant";
import Decimal from "decimal.js";
import moment from "moment";
import VueClipboards from "vue-clipboards";
import uploadPhoto from '@/views/uploadPhoto'


import {
  cancelOrder,
  confirmOrder,
  getOrder,
  startService,
  remindContinued,
  noticeUserUpdateWechatId,
  isFcChangeFlag,
  getOrderRewardEffect
} from "@/api/clerk/order";
import { addOrderContinuedApply } from "@/api/clerk/order_continued_apply";
import certification from "@/views/certification";
import lrz from 'lrz'
import ViolationSelect from '@/components/common/violation-select'
import RewardSpecialEffects from '@/components/common/gift/reward-special-effects'
import NoWechat from '@/views/clerk/order/component/no-wechat'
import OrderConfirmHint from '@/views/clerk/order/component/order-confirm-hint'

Vue.use(Panel)
  .use(Cell)
  .use(CellGroup)
  .use(Button)
  .use(Tag)
  .use(Icon)
  .use(Toast)
  .use(Dialog)
  .use(Uploader)
  .use(Field).use(Radio).use(RadioGroup);

Vue.use(VueClipboards);

export default {
  name: "clerk-order-detail",
  components: {
    certification,
    ViolationSelect,
    RewardSpecialEffects,
    uploadPhoto,
    NoWechat,
    OrderConfirmHint,
  },

  data() {
    return {
      showViolation: false,
      fileList: [],
      continuedApplyFileList: [],
      UserInfoEnum: this.$store.state.UserInfoEnum,
      show: false,
      value: "",
      model: null,
      sign: null,
      btnConfirmDisabled: true,
      confirmCountDown: 3,
      cancelCountDown: null,
      canClerkCancelOrder: null,
      showOrderContinuedApplyDialog: false,
      orderContinuedApplyMessage: null,
      isVerify: false,
      clerkContinuedApplyUpload: false,
      remindUserContinued: false,
      clerkWechatCode: false,
      refundPath: null,
    };
  },
  computed: {
    copyUserWechatId() {
      if (this.model) {
        return this.model.userWechatId;
      }
      return null;
    },
  },
  methods: {
    showCreatedTime(createTime){
      // 7天前的时间戳
      let daysAgo7 = moment().add(-7,'d').valueOf()
      return createTime - daysAgo7 > 0;
    },
    toChat(userId) {
      console.log("userId",userId)
      this.$router.push({
        path: '/clerk/chat/roomInfo',
        query: {
          userId: userId,
        }
      })
    },
    uploadimgFile(imgarr){
      this.fileList = imgarr
    },

    uploadimg(imgarr){
      this.continuedApplyFileList = imgarr
    },

    //获取订单的礼物
    getOrderRewardEffect() {
      getOrderRewardEffect(this.$route.params.id).then(res => {
        const data = res.data;
        if (data.code === 0) {
          let specialEffects = data.specialEffects
          if (specialEffects) {
            this.$refs.child.rewardSpecialEffects(specialEffects)
          }
        }
      })
    },
    changeShowViolation(val){
      this.showViolation = val
    },
    // 读取前
    beforeRead() {
      return true;
    },
    // 读取后
    afterRead(file) {
      let files = []
      if (!file.length) {
        files.push(file)
      } else {
        files = file
      }
      for (let item of files) {
        // 压缩图片
        lrz(item.file, {
          width: 800
        }).then(function (res) {
          item.content = res.base64
        })
      }
    },
    // 删除前
    beforeDelete() {
      if (this.fileList != null && this.fileList.length == 1) {
        Toast('至少保留1张照片');
        return false;
      }
      return true;
    },
    // 续单申请截图读取后
    continuedApplyAfterRead(file) {
      let files = []
      if (!file.length) {
        files.push(file)
      } else {
        files = file
      }
      for (let item of files) {
        // 压缩图片
        lrz(item.file, {
          width: 800
        }).then(function (res) {
          item.content = res.base64
        })
      }
    },
    cancellation() {
      if (this.value == "") {
        return Toast("请输入原因");
      }
      // 开启截图开关(服务中的才需上传截图)
      if(this.model.status === 1 && this.$ClerkPermission.requireUploadPictureWhenCancelWaitServiceOrder && this.fileList.length == 0){
        return Toast("请上传截图");
      }
      Toast.loading({
        mask: true,
        message: "加载中...",
      });
      cancelOrder(this.$route.params.id, this.value,JSON.stringify(this.fileList),this.refundPath).then((res) => {
        Toast.clear();
        const data = res.data;
        let options = {};
        if (data.code == 0) {
          this.model = null;
          options = {
            title: "取消订单成功",
          };
        } else {
          options = {
            title: "取消订单失败",
            message: data.msg,
          };
        }
        Dialog.alert(options).then(() => [this.loadData()]);
      });

    },
    formatDate(date, format) {
      if (!date) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD";
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString();
      }
      return "";
    },
    // 格式化时间差
    formatTimeDiff(start, end, status) {
      start = moment(start);
      end = moment(end);
      const diffSeconds = end.diff(start, "seconds");
      if (status === 2 && diffSeconds < 1) {
        return '即将完成'
      }
      if (diffSeconds < 60) {
        return `${diffSeconds}秒`;
      }
      const diffMinutes = end.diff(start, "minutes");
      if (diffMinutes < 60) {
        return `${diffMinutes}分钟`;
      }
      const diffHours = end.diff(start, "hours");
      if (diffHours < 24) {
        return `${diffHours}小时`;
      }
      const diffDays = end.diff(start, "days");
      return `${diffDays}天`;
    },
    copyCallback(success) {
      if (success) {
        Toast("复制成功");
      } else {
        Toast("复制失败，请长按文本复制");
      }
    },
    // 启用“确认订单”按钮倒计时
    startConfirmEnableCountDown() {
      let interval = window.setInterval(() => {
        this.confirmCountDown--;
        if (this.confirmCountDown <= 0) {
          window.clearInterval(interval);
          this.btnConfirmDisabled = false;
        }
      }, 1000);
    },
    hideCancelOrderButtonCountDown() {
      let interval = window.setInterval(() => {
        this.cancelCountDown--;
        if (this.cancelCountDown <= 0) {
          window.clearInterval(interval);
          this.canClerkCancelOrder = false;
        }
      }, 1000);
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: "加载中...",
      });
      getOrder(this.$route.params.id).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.model = data.order;
          this.noticeTypeList = data.noticeTypeList;
          this.sign = data.sign;
          this.clerkContinuedApplyUpload = data.clerkContinuedApplyUpload;
          this.remindUserContinued=data.remindUserContinued
          this.clerkWechatCode=data.clerkWechatCode
          this.cancelCountDown = this.$ClerkPermission.cancelOrderStartServiceWithinTime * 60;
          this.confirmCountDown =
            data.order.confirmCountDown != null
              ? data.order.confirmCountDown
              : this.confirmCountDown;
          if (this.confirmCountDown <= 0 || data.order.type == "assigned") {
            this.btnConfirmDisabled = false;
          } else {
            this.startConfirmEnableCountDown();
          }
          let validTime = moment(this.model.startTime).add(
              this.$ClerkPermission.cancelOrderStartServiceWithinTime,
            "m"
          );
          let now = moment();
          this.canClerkCancelOrder =
              this.$ClerkPermission.refundableOrderStatus.includes(2) && now < validTime;
          if (this.canClerkCancelOrder) {
            this.hideCancelOrderButtonCountDown();
          }
          if (this.model.status===3&&this.model.type==='reward' && this.$route.query.type==="reward"){
            this.getOrderRewardEffect()
          }
          if (data.revokeInfo){
            let revokeInfo = data.revokeInfo
            this.$nextTick(()=>{
              this.$refs.orderConfirmHint.show(revokeInfo.remark,revokeInfo.type)
            })
          }
          if(this.model.payMode === 'balance'){
            this.refundPath = 'balance'
          }else if(this.$ClerkPermission.refundMethod === 'choose'){
            this.refundPath = 'original'
          }else{
            this.refundPath = this.$ClerkPermission.refundMethod
          }
        }else if(data.code == 10001){
          this.$nextTick(()=>{
            this.$refs.orderConfirmHint.show(data.remark,data.type)
          })
        } else {
          Dialog.alert({
            title: "加载失败",
            message: data.msg,
          });
        }
      });
    },
    confirmOrder() {
      Toast.loading({
        mask: true,
        message: "请稍候...",
      });
      confirmOrder(this.$route.params.id).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: "接单成功",
          }).then(() => {
            this.loadData();
          });
        } else {
          this.loadData();

          if (data.msg == this.$store.state.label.clerkLabel + "未实名") {
            this.isVerify = true;
          } else {
            Dialog.alert({
              title: "接单失败",
              message: data.msg,
            });
          }
        }
      });
    },
    // 取消订单
    cancelOrder() {
      Dialog.confirm({
        title: "确定要取消订单？",
        message: "此操作不可撤销！",
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        cancelOrder(this.$route.params.id,null,null,this.refundPath).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            this.model = null;
            Dialog.alert({
              title: "取消订单成功",
            }).then(() => [this.loadData()]);
          } else {
            Dialog.alert({
              title: "取消订单失败",
              message: data.msg,
            });
          }
        });
      });
    },
    clickRemindContinued(){
      // 弹出框
      Dialog.confirm({
        title: '提醒用户续单',
        message:'每单限一次哦~'
      }).then(() => {
        Toast.loading({
          message: '提醒中...',
          forbidClick: true,
        });
        remindContinued(this.$route.params.id).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "提醒成功",
            });
            this.model.remind=true
          } else {
            Dialog.alert({
              title: "提醒失败",
              message: data.msg,
            });
            this.loadData();
          }
        });
      })
    },
    // 开始服务
    startService() {
      let shopId = this.$store.state.shop.id
      let message = "请确认已成功添加用户微信！\n点击确认后开始服务计时。"
      if (1916 === shopId) {
        message = "请确认已成功加入初恋の小窝\n点击确认后开始服务计时。"
      } else if (2184 === shopId) {
        message = "请确认已成功联系用户\n点击确认后开始服务计时。"
      } else if (2308 === shopId) {
        message = "请确认已成功加入虚拟の小群！\n点击确认后开始服务计时。"
      }else if (2362 === shopId) {
        message = "请确认已和点单用户在游戏中！\n点击确认后开始服务计时。"
      }
      Dialog.confirm({
        title: "开始服务",
        message: message,
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        startService(this.$route.params.id).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "已开始服务",
            }).then(() => {
              this.loadData();
            });
          } else {
            this.loadData();
            Dialog.alert({
              title: "开始服务失败",
              message: data.msg,
            });
          }
        });
      });
    },
    onOrderContinuedApplyDialogClose(action, done) {
      if (action == "confirm") {
        if (
          this.orderContinuedApplyMessage != null &&
          this.orderContinuedApplyMessage.length > 100
        ) {
          Toast("消息不能超过100个字");
          return done(false);
        }

        // 开启截图开关
        if(this.clerkContinuedApplyUpload && this.continuedApplyFileList.length == 0){
          Toast("请上传至少一张截图");
          return done(false);
        }
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        addOrderContinuedApply(
          this.$route.params.id,
          this.orderContinuedApplyMessage,
          JSON.stringify(this.continuedApplyFileList)
        ).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "申请成功",
            }).then(() => {
              this.loadData();
            });
          } else {
            this.loadData();
            Dialog.alert({
              title: "申请失败",
              message: data.msg,
            });
          }
        });

        done();
      } else {
        done();
      }
    },
    refundImgClick(i){
      ImagePreview({
        images: this.model.refundPhotoUrls,
        startPosition: i,
      })
    },
    imgClick(i) {
      ImagePreview({
        images: this.model.orderFeedBack.photoUrls,
        startPosition: i,
      });
    },
    isFirstContinuedChangeFlag(orderId){
      isFcChangeFlag(orderId).then(res=>{
        const data = res.data;
        if(data.code!== 0){
          Dialog.alert({
            title: "申请失败",
            message: data.msg,
          });
        }else{
          this.showOrderContinuedApplyDialog = true;
        }
      })

    }
  },
  mounted() {
    this.loadData();
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  },
  watch: {
    $route: function (to, from) {
      //从订单反馈过来的话就直接重新loadDate()
      if (from.meta.title === "订单反馈") {
        this.loadData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;

  .panel-info {
    margin-top: 10px;

    .content {
      font-size: 14px;
      padding: 10px 15px;

      .row {
        .user_head {
          position: relative;
          padding: 10px;
          .level {
            position: absolute;
            left: 50%;
            height: 10px;
            font-size: 10px;
            white-space: nowrap;
            bottom: 5px;
            transform: translateX(-50%);
          }

          .avatarFrame {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }

  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }

  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }

  .bottom-bar {
    padding: 10px 15px;
    /*background: #fff;*/
    /*box-shadow: 0 0 3px 0px #333;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
  }

  .commentBox {
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .imgStyle {
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }

  .screenshot {
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }

  .screenshotImg {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .module {
    margin-top: 15px;
    padding: 0px 15px;
    position: relative;

    /deep/ .van-cell {
      padding: 15px 0;
      background: transparent;
      font-size: 14px;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;

      &.module-title {
        padding-bottom: 0;
      }

      .van-cell__title {
        width: 90px;
        flex: none;
        box-sizing: border-box;
        font-weight: 600;
        color: #333333;
      }

      .van-cell__value {
        font-weight: 400;
        color: #999999;
      }

      &.van-cell--required {
        &::before {
          left: 0px;
        }
      }
    }
  }

  .image-uploader {
    /deep/ .van-uploader__wrapper {
      .van-uploader__preview {
        .van-uploader__preview-delete {
          top: 0;
          right: 0;
          color: var(--primary-color);
        }
      }
    }
  }
  .wx {
    height: 20px;
    line-height: 18px;
    background-color: #f87d23;
    border: 1px solid #f87d23;
    margin-right: 15px
  }

}
</style>
